import React, { useRef, useState } from 'react-x';
import propTypes from 'prop-types-x';
import classNames from 'classnames';
import { useUpdateEffect } from '../hooks/useUpdateEffect.js';
import { MEDIA_TYPES } from '../../constants/config.js';

const defaultVideoConfig = {
  playsInline: true,
  preload: 'auto',
  autoPlay: true, 
  loop: true,
  controls: false,
  muted: true
};

export function BackgroundMedia(props) {

  const { 
    mediaType, 
    mediaUrl, 
    videoPoster,
    audioMuteButton, 
    overlay, 
    overlayModifier
  } = props;

  const videoConfig = Object.assign({}, defaultVideoConfig, props.videoConfig);
  const videoRef = useRef();
  const [muted, setMuted] = useState(videoConfig.muted);
  const isVideo = mediaType === MEDIA_TYPES.video;
  const block = 'c-background-media';

  useUpdateEffect(() => {
    if (isVideo) {
      videoRef.current.muted = muted;
    }
  }, [muted]);

  useUpdateEffect(() => {   
    if (isVideo) {
      videoRef.current?.load();
    }
  }, [mediaUrl]);

  function toggleMute() {
    setMuted(prevValue => !prevValue);
  };

  return (
    <div className={`${block}`}>
      {
        isVideo ? 
          <div className={
            classNames({
              [`${block}__container`]: true,
              [`${block}__overlay`]: overlay,
              [`${block}__overlay--${overlayModifier}`]: overlayModifier
            })}>
            <video 
            className={`${block}__video`} 
            ref={videoRef} 
            poster={videoPoster}
            { ...videoConfig }
            >
              <source src={`${mediaUrl}#t=0.1`} type='video/mp4' />
            </video>
            { 
              audioMuteButton && 
                <button 
                className={
                  classNames({
                    [`${block}__mute-button`]: true,
                    [`${block}__mute-button--active`]: muted
                  })}
                onClick={toggleMute}>
                </button>
            }
          </div>
          :
          <div className={
            classNames({
              [`${block}__image`]: true,
              [`${block}__overlay`]: overlay,
              [`${block}__overlay--${overlayModifier}`]: overlayModifier
            })} 
            style={{backgroundImage: `url(${mediaUrl})`}}>
            </div>
      }
    </div>
  )
};

BackgroundMedia.propTypes = {
  mediaType: propTypes.string.isRequired,
  mediaUrl: propTypes.string.isRequired,
  videoConfig: propTypes.object,
  audioMuteButton: propTypes.bool,
  overlay: propTypes.bool,
  overlayModifier: propTypes.string
};

BackgroundMedia.defaultProps = {
  audioMuteButton: false,
  overlay: false
};
